export const storageKey = {
  user: "user",
};
